import { useUserType } from '@labrav/common'
import { useSelector } from '../../store'

export const isProductActive = (product: string) => {
  const activeProducts = useSelector<string[]>(
    state =>
      (state.AccountData.user.partnerData?.activeProducts as string[]) || []
  )
  return activeProducts.includes(product)
}

export const useActiveProducts = () => {
  const activeProducts = useSelector<string[]>(
    state =>
      (state.AccountData.user.partnerData?.activeProducts as string[]) || []
  )
  return activeProducts
}

export const customerFormData = () => {
  const userType = useUserType()
  const partnerData = useSelector(
    state => state.AccountData[userType]?.partnerData
  )
  return {
    subscribedProducts:
      (partnerData?.subscribedProducts as
        | { FLYOUT?: { cloudProviders?: string[]; plan?: string } }
        | undefined) || {},
    crmType: (partnerData?.crmType as string | undefined) || null,
  }
}
